import React, { useContext, useEffect, useRef, useState } from "react"; // ✅ useRef add kiya
import { Container } from "react-bootstrap";
import "../../../assets/css/gcadmin/adminissuedbooks/AdminIssuedBooks.css";
import axios from "axios";
import Swal from "sweetalert2";
import AppContext from "../../../context/AppContext";
import Pagination from "../../../components/general/pagination/Pagination";
import Loader from "../../../components/general/loader/Loader";

const STATUS_OPTIONS = ["All", "issued", "returned", "lost", "damaged"];
const ITEMS_PER_PAGE = 10;

/* ── Fine calculator ── */
const calcFine = (dueDateStr, finePerDay = 10) => {
  if (!dueDateStr) return 0;
  const today   = new Date();
  today.setHours(0, 0, 0, 0);
  const dueDate = new Date(dueDateStr);
  dueDate.setHours(0, 0, 0, 0);
  if (today <= dueDate) return 0;
  const diffMs   = today - dueDate;
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  return diffDays * finePerDay;
};

const isOverdueCheck = (dueDateStr) => {
  if (!dueDateStr) return false;
  const today   = new Date();
  today.setHours(0, 0, 0, 0);
  const dueDate = new Date(dueDateStr);
  dueDate.setHours(0, 0, 0, 0);
  return today > dueDate;
};

/* ══════════════════════════════════════════
   Detail Modal
══════════════════════════════════════════ */
const DetailModal = ({ record, isTeacher, finePerDay, onClose }) => {
  const [visible, setVisible] = useState(false);
  useEffect(() => { setTimeout(() => setVisible(true), 30); }, []);
  const handleClose = () => { setVisible(false); setTimeout(onClose, 280); };

  const fine = isTeacher ? 0 : (record.fine || calcFine(record.due_date, finePerDay));

  const rows = isTeacher
    ? [
        { label: "Teacher Name",  value: record.lbteacher?.name  || "—" },
        { label: "Teacher Email", value: record.lbteacher?.email || "—" },
        { label: "Book",          value: record.lbbook?.title    || "—" },
        { label: "Author",        value: record.lbbook?.author   || "—" },
        { label: "Issue Date",    value: record.issue_date       || "—" },
        { label: "Due Date",      value: record.due_date         || "—" },
        { label: "Status",        value: record.status           || "—" },
      ]
    : [
        { label: "Student Name",  value: record.lbstudent?.fullName || "—" },
        { label: "Roll No",       value: record.lbstudent?.roll_no  || "—" },
        { label: "Book",          value: record.lbbook?.title       || "—" },
        { label: "Author",        value: record.lbbook?.author      || "—" },
        { label: "Issue Date",    value: record.issue_date          || "—" },
        { label: "Due Date",      value: record.due_date            || "—" },
        { label: "Status",        value: record.status              || "—" },
        { label: "Fine",          value: fine > 0 ? `Rs. ${fine}` : "—" },
      ];

  return (
    <div className={`gcAdminIB-backdrop ${visible ? "gcAdminIB-backdrop--in" : ""}`} onClick={handleClose}>
      <div className={`gcAdminIB-modal ${visible ? "gcAdminIB-modal--in" : ""}`} onClick={e => e.stopPropagation()}>
        <div className="gcAdminIB-modal-header">
          <h5 className="gcAdminIB-modal-title">Issue Details</h5>
          <button className="gcAdminIB-modal-close" onClick={handleClose}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"/>
            </svg>
          </button>
        </div>
        <div className="gcAdminIB-modal-body">
          {rows.map(({ label, value }) => (
            <div className="gcAdminIB-detail-row" key={label}>
              <span className="gcAdminIB-detail-label">{label}</span>
              <span className={`gcAdminIB-detail-value ${
                label === "Status" && value === "issued"   ? "gcAdminIB-detail-value--green" :
                label === "Status" && value === "returned" ? "gcAdminIB-detail-value--blue"  :
                label === "Fine"   && value !== "—"        ? "gcAdminIB-detail-value--red"   :
                label === "Teacher Email"                  ? "gcAdminIB-detail-value--email" : ""
              }`}>
                {value}
              </span>
            </div>
          ))}
        </div>
        <div className="gcAdminIB-modal-footer-single">
          <button className="gcAdminIB-close-btn" onClick={handleClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

/* ══════════════════════════════════════════
   Return Confirm Modal
══════════════════════════════════════════ */
const ReturnModal = ({ record, isTeacher, finePerDay, onClose, onConfirm }) => {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => { setTimeout(() => setVisible(true), 30); }, []);
  const handleClose = () => { setVisible(false); setTimeout(onClose, 280); };

  const finePreview = isTeacher ? 0 : calcFine(record.due_date, finePerDay);
  const overdueDays = finePreview > 0 ? finePreview / finePerDay : 0;
  const overdue     = isTeacher ? isOverdueCheck(record.due_date) : finePreview > 0;

  return (
    <div className={`gcAdminIB-backdrop ${visible ? "gcAdminIB-backdrop--in" : ""}`} onClick={handleClose}>
      <div className={`gcAdminIB-modal gcAdminIB-modal--sm ${visible ? "gcAdminIB-modal--in" : ""}`}
        onClick={e => e.stopPropagation()}>

        <div className="gcAdminIB-return-icon">
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none">
            <path d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3"
              stroke="#1a5f7a" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>

        <h5 className="gcAdminIB-delete-title">Mark as Returned?</h5>

        <p className="gcAdminIB-delete-msg">
          Returning <strong>"{record.lbbook?.title}"</strong> issued to{" "}
          <strong>{isTeacher ? record.lbteacher?.name : record.lbstudent?.fullName}</strong>.
        </p>

        {!isTeacher && (
          <div className={`gcAdminIB-fine-preview ${overdue ? "gcAdminIB-fine-preview--overdue" : "gcAdminIB-fine-preview--ok"}`}>
            {overdue ? (
              <>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
                    stroke="#d97706" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M12 9v4M12 17h.01" stroke="#d97706" strokeWidth="2" strokeLinecap="round"/>
                </svg>
                <div>
                  <div className="gcAdminIB-fine-preview__title">Overdue — Fine Applicable</div>
                  <div className="gcAdminIB-fine-preview__detail">
                    {overdueDays} day{overdueDays > 1 ? "s" : ""} overdue × Rs. {finePerDay} ={" "}
                    <strong>Rs. {finePreview}</strong>
                  </div>
                </div>
              </>
            ) : (
              <>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M20 6L9 17l-5-5" stroke="#0f8a65" strokeWidth="2.2"
                    strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <div>
                  <div className="gcAdminIB-fine-preview__title">On Time — No Fine</div>
                  <div className="gcAdminIB-fine-preview__detail">Returned within due date.</div>
                </div>
              </>
            )}
          </div>
        )}

        {isTeacher && overdue && (
          <div className="gcAdminIB-fine-preview gcAdminIB-fine-preview--overdue">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
                stroke="#d97706" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 9v4M12 17h.01" stroke="#d97706" strokeWidth="2" strokeLinecap="round"/>
            </svg>
            <div>
              <div className="gcAdminIB-fine-preview__title">Book is Overdue</div>
            </div>
          </div>
        )}

        <div className="gcAdminIB-delete-actions">
          <button className="gcAdminIB-delete-cancel" onClick={handleClose} disabled={loading}>
            Cancel
          </button>
          <button
            className="gcAdminIB-return-confirm"
            disabled={loading}
            onClick={() => { onConfirm(record, isTeacher, setLoading, handleClose); }}
          >
            {loading ? <span className="gcAdminIB-btn-spinner" /> : "Confirm Return"}
          </button>
        </div>
      </div>
    </div>
  );
};

/* ══════════════════════════════════════════
   Mark as Lost — Confirm Modal
══════════════════════════════════════════ */
const LostModal = ({ record, isTeacher, lostFine, onClose, onConfirm }) => {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => { setTimeout(() => setVisible(true), 30); }, []);
  const handleClose = () => { setVisible(false); setTimeout(onClose, 280); };

  return (
    <div className={`gcAdminIB-backdrop ${visible ? "gcAdminIB-backdrop--in" : ""}`} onClick={handleClose}>
      <div className={`gcAdminIB-modal gcAdminIB-modal--sm ${visible ? "gcAdminIB-modal--in" : ""}`}
        onClick={e => e.stopPropagation()}>

        <div className="gcAdminIB-return-icon" style={{ background: "#fdecec" }}>
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none">
            <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
              stroke="#d63031" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 9v4M12 17h.01" stroke="#d63031" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </div>

        <h5 className="gcAdminIB-delete-title">Mark Book as Lost?</h5>

        <p className="gcAdminIB-delete-msg">
          Marking <strong>"{record.lbbook?.title}"</strong> as lost, issued to{" "}
          <strong>{isTeacher ? record.lbteacher?.name : record.lbstudent?.fullName}</strong>.
        </p>

        <div className="gcAdminIB-fine-preview gcAdminIB-fine-preview--overdue">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
              stroke="#d97706" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 9v4M12 17h.01" stroke="#d97706" strokeWidth="2" strokeLinecap="round"/>
          </svg>
          <div>
            <div className="gcAdminIB-fine-preview__title">Lost Book Fine</div>
            <div className="gcAdminIB-fine-preview__detail">
              A fine of <strong>Rs. {lostFine}</strong> will be applied.
            </div>
          </div>
        </div>

        <div className="gcAdminIB-delete-actions">
          <button className="gcAdminIB-delete-cancel" onClick={handleClose} disabled={loading}>
            Cancel
          </button>
          <button
            className="gcAdminIB-delete-confirm"
            disabled={loading}
            onClick={() => { onConfirm(record, isTeacher, setLoading, handleClose); }}
          >
            {loading ? <span className="gcAdminIB-btn-spinner" /> : "Confirm Lost"}
          </button>
        </div>
      </div>
    </div>
  );
};

/* ══════════════════════════════════════════
   Mark as Damaged — Confirm Modal
══════════════════════════════════════════ */
const DamagedModal = ({ record, isTeacher, damagedFine, onClose, onConfirm }) => {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => { setTimeout(() => setVisible(true), 30); }, []);
  const handleClose = () => { setVisible(false); setTimeout(onClose, 280); };

  return (
    <div className={`gcAdminIB-backdrop ${visible ? "gcAdminIB-backdrop--in" : ""}`} onClick={handleClose}>
      <div className={`gcAdminIB-modal gcAdminIB-modal--sm ${visible ? "gcAdminIB-modal--in" : ""}`}
        onClick={e => e.stopPropagation()}>

        <div className="gcAdminIB-return-icon" style={{ background: "#fff4e5" }}>
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none">
            <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
              stroke="#d97706" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 9v4M12 17h.01" stroke="#d97706" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </div>

        <h5 className="gcAdminIB-delete-title">Mark Book as Damaged?</h5>

        <p className="gcAdminIB-delete-msg">
          Marking <strong>"{record.lbbook?.title}"</strong> as damaged, issued to{" "}
          <strong>{isTeacher ? record.lbteacher?.name : record.lbstudent?.fullName}</strong>.
        </p>

        <div className="gcAdminIB-fine-preview gcAdminIB-fine-preview--overdue">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
              stroke="#d97706" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 9v4M12 17h.01" stroke="#d97706" strokeWidth="2" strokeLinecap="round"/>
          </svg>
          <div>
            <div className="gcAdminIB-fine-preview__title">Damaged Book Fine</div>
            <div className="gcAdminIB-fine-preview__detail">
              A fine of <strong>Rs. {damagedFine}</strong> will be applied.
            </div>
          </div>
        </div>

        <div className="gcAdminIB-delete-actions">
          <button className="gcAdminIB-delete-cancel" onClick={handleClose} disabled={loading}>
            Cancel
          </button>
          <button
            className="gcAdminIB-delete-confirm"
            disabled={loading}
            onClick={() => { onConfirm(record, isTeacher, setLoading, handleClose); }}
          >
            {loading ? <span className="gcAdminIB-btn-spinner" /> : "Confirm Damaged"}
          </button>
        </div>
      </div>
    </div>
  );
};

/* ══════════════════════════════════════════
   Reusable Table Section
══════════════════════════════════════════ */
const BookTable = ({ records, isTeacher, rowVisible, finePerDay, onView, onReturn, onLost, onDamaged }) => {
  const tableClass = isTeacher ? "gcAdminIB-table--teacher" : "gcAdminIB-table--student";

  return (
    <div className="gcAdminIB-table-wrap">
      <table className={tableClass}>
        <thead>
          <tr className="gcAdminIB-thead-row">
            {isTeacher ? (
              <>
                <th className="gcAdminIB-th">Teacher</th>
                <th className="gcAdminIB-th">Book</th>
                <th className="gcAdminIB-th">Issue Date</th>
                <th className="gcAdminIB-th">Due Date</th>
                <th className="gcAdminIB-th">Status</th>
                <th className="gcAdminIB-th gcAdminIB-th--center">Actions</th>
              </>
            ) : (
              <>
                <th className="gcAdminIB-th">Student</th>
                <th className="gcAdminIB-th">Book</th>
                <th className="gcAdminIB-th">Issue Date</th>
                <th className="gcAdminIB-th">Due Date</th>
                <th className="gcAdminIB-th">Status</th>
                <th className="gcAdminIB-th">Fine</th>
                <th className="gcAdminIB-th gcAdminIB-th--center">Actions</th>
              </>
            )}
          </tr>
        </thead>
        <tbody>
          {records?.map((record, i) => {
            const overdue = isTeacher
              ? isOverdueCheck(record.due_date) && record.status !== "returned"
              : calcFine(record.due_date, finePerDay) > 0 && record.status !== "returned";
            const liveFinePrev = isTeacher ? 0 : calcFine(record.due_date, finePerDay);

            const isActive = record.status === "issued";

            return (
              <tr
                key={record.id}
                className={`gcAdminIB-tr ${rowVisible[i] ? "gcAdminIB-tr--visible" : ""}`}
                style={{ transitionDelay: `${i * 0.05}s` }}
              >
                <td className="gcAdminIB-td">
                  {isTeacher ? (
                    <>
                      <div className="gcAdminIB-teacher-name">{record.lbteacher?.name || "—"}</div>
                      <div className="gcAdminIB-teacher-email">{record.lbteacher?.email || "—"}</div>
                    </>
                  ) : (
                    <>
                      <div className="gcAdminIB-student-name">{record.lbstudent?.fullName || "—"}</div>
                      <div className="gcAdminIB-student-id">{record.lbstudent?.roll_no || "—"}</div>
                    </>
                  )}
                </td>

                <td className="gcAdminIB-td gcAdminIB-td--book">
                  <div className="gcAdminIB-book-title">{record.lbbook?.title || "—"}</div>
                  <div className="gcAdminIB-book-author">{record.lbbook?.author || "—"}</div>
                </td>

                <td className="gcAdminIB-td gcAdminIB-td--date">{record.issue_date || "—"}</td>

                <td className="gcAdminIB-td gcAdminIB-td--date">
                  <span className={overdue ? "gcAdminIB-date--overdue" : ""}>
                    {record.due_date || "—"}
                  </span>
                </td>

                <td className="gcAdminIB-td">
                  <span
                    className={`gcAdminIB-status-badge ${
                      overdue                      ? "gcAdminIB-status--overdue"  :
                      record.status === "issued"   ? "gcAdminIB-status--ontime"   :
                      record.status === "returned" ? "gcAdminIB-status--returned" : ""
                    }`}
                    style={
                      record.status === "lost"    ? { background: "#fdecec", color: "#d63031" } :
                      record.status === "damaged" ? { background: "#fff4e5", color: "#d97706" } :
                      undefined
                    }
                  >
                    {overdue ? (
                      <>
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" style={{ marginRight: 4 }}>
                          <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
                            stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <line x1="12" y1="9" x2="12" y2="13" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                          <line x1="12" y1="17" x2="12.01" y2="17" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                        </svg>
                        Overdue
                      </>
                    ) : record.status === "issued"   ? "Issued"
                      : record.status === "returned" ? "Returned"
                      : record.status === "lost"     ? "Lost"
                      : record.status === "damaged"  ? "Damaged"
                      : record.status}
                  </span>
                </td>

                {!isTeacher && (
                  <td className="gcAdminIB-td gcAdminIB-td--fine">
                    {(record.status === "returned" || record.status === "lost" || record.status === "damaged") && record.fine ? (
                      <span className="gcAdminIB-fine-amount">Rs. {record.fine}</span>
                    ) : overdue ? (
                      <span className="gcAdminIB-fine-amount gcAdminIB-fine-amount--live">
                        Rs. {liveFinePrev}
                      </span>
                    ) : (
                      <span className="gcAdminIB-fine-none">—</span>
                    )}
                  </td>
                )}

                <td className="gcAdminIB-td gcAdminIB-td--actions">
                  <div className="gcAdminIB-actions">
                    <button
                      className="gcAdminIB-action-btn gcAdminIB-action-btn--view"
                      onClick={() => onView(record)}
                      title="View Details"
                    >
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                          stroke="currentColor" strokeWidth="1.9" strokeLinecap="round"/>
                        <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.9"/>
                      </svg>
                    </button>

                    {isActive ? (
                      <>
                        <button
                          className="gcAdminIB-return-btn"
                          onClick={() => onReturn(record)}
                          title="Return Book"
                        >
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                            <path d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3"
                              stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                          Return
                        </button>

                        <button
                          className="gcAdminIB-return-btn"
                          style={{ background: "#fdecec", color: "#d63031", borderColor: "#f5c6c6" }}
                          onClick={() => onLost(record)}
                          title="Mark as Lost"
                        >
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                            <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                          </svg>
                          Lost
                        </button>

                        <button
                          className="gcAdminIB-return-btn"
                          style={{ background: "#fff4e5", color: "#d97706", borderColor: "#fcd9a8" }}
                          onClick={() => onDamaged(record)}
                          title="Mark as Damaged"
                        >
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                            <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
                              stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                          Damaged
                        </button>
                      </>
                    ) : (
                      <span className="gcAdminIB-returned-tag">
                        {record.status === "returned" ? "Returned"
                          : record.status === "lost" ? "Lost"
                          : record.status === "damaged" ? "Damaged"
                          : record.status}
                      </span>
                    )}
                  </div>
                </td>
              </tr>
            );
          })}

          {records?.length === 0 && (
            <tr>
              <td colSpan={isTeacher ? 6 : 7} className="gcAdminIB-td gcAdminIB-td--empty">
                No records found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

/* ══════════════════════════════════════════
   Main Page
══════════════════════════════════════════ */
const AdminIssuedBooks = () => {
  const [activeTab,      setActiveTab]      = useState("students");
  const [studentRecords, setStudentRecords] = useState([]);
  const [teacherRecords, setTeacherRecords] = useState([]);
  const [search,         setSearch]         = useState("");
  const [filter,         setFilter]         = useState("All");
  const [viewRecord,     setViewRecord]     = useState(null);
  const [viewIsTeacher,  setViewIsTeacher]  = useState(false);
  const [returnRecord,   setReturnRecord]   = useState(null);
  const [returnIsTeacher,setReturnIsTeacher]= useState(false);
  const [lostRecord,     setLostRecord]     = useState(null);
  const [lostIsTeacher,  setLostIsTeacher]  = useState(false);
  const [damagedRecord,  setDamagedRecord]  = useState(null);
  const [damagedIsTeacher, setDamagedIsTeacher] = useState(false);
  const [visible,        setVisible]        = useState(false);
  const [sRowVisible,    setSRowVisible]    = useState([]);
  const [tRowVisible,    setTRowVisible]    = useState([]);
  const [bookConfig,     setBookConfig]     = useState({ fine_per_day: 10, lost_book_fine: 200, damaged_book_fine: 50 });
  const [loading,        setLoading]        = useState(false); // ✅ initial API fetch loading
  const [sCurrentPage,   setSCurrentPage]   = useState(1);
  const [tCurrentPage,   setTCurrentPage]   = useState(1);

  // ✅ Tab switch / filter / pagination change hone par sirf currently
  //    active tab ke current page (10 records) ki loading dikhane ke liye
  const [viewLoading, setViewLoading] = useState(false);
  const isFirstRender = useRef(true);

  const { baseUrl, authToken } = useContext(AppContext);

  useEffect(() => { setTimeout(() => setVisible(true), 60); }, []);

  const fetchBookConfig = () => {
    axios
      .post(`${baseUrl}/admin/bookConfig/getBookConfiguration`, {},
        { headers: { "Authorization": `Bearer ${authToken}` } })
      .then((res) => {
        if (res.data.success && res.data.bookConfiguration) {
          setBookConfig(res.data.bookConfiguration);
        }
      })
      .catch((err) => console.log(err));
  };

  const fetchAllBookings = () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("status", "issued");
    axios
      .post(`${baseUrl}/admin/bookings/fetchAllBookings`, formData,
        { headers: { "Authorization": `Bearer ${authToken}` } })
      .then((res) => {
        setLoading(false);
        if (res.data.success === true) {
          const all = res.data.bookings;
          setStudentRecords(all.filter(r => r.lbstudent_id && !r.lbteacher_id));
          setTeacherRecords(all.filter(r => r.lbteacher_id && !r.lbstudent_id));
        }
      })
      .catch((err) => { setLoading(false); console.log(err); });
  };

  useEffect(() => { fetchAllBookings(); fetchBookConfig(); }, []);

  const filteredStudentRecords = studentRecords.filter((r) => {
    const nameMatch = r.lbstudent?.fullName?.toLowerCase().includes(search.toLowerCase());
    const bookMatch = r.lbbook?.title?.toLowerCase().includes(search.toLowerCase());
    const matchFilter = filter === "All" || r.status === filter;
    return (nameMatch || bookMatch) && matchFilter;
  });

  const filteredTeacherRecords = teacherRecords.filter((r) => {
    const nameMatch = r.lbteacher?.name?.toLowerCase().includes(search.toLowerCase());
    const bookMatch = r.lbbook?.title?.toLowerCase().includes(search.toLowerCase());
    const matchFilter = filter === "All" || r.status === filter;
    return (nameMatch || bookMatch) && matchFilter;
  });

  const paginatedStudentRecords = filteredStudentRecords.slice(
    (sCurrentPage - 1) * ITEMS_PER_PAGE,
    sCurrentPage * ITEMS_PER_PAGE
  );
  const paginatedTeacherRecords = filteredTeacherRecords.slice(
    (tCurrentPage - 1) * ITEMS_PER_PAGE,
    tCurrentPage * ITEMS_PER_PAGE
  );

  useEffect(() => {
    setSCurrentPage(1);
    setTCurrentPage(1);
    // eslint-disable-next-line
  }, [search, filter]);

  useEffect(() => {
    setSRowVisible([]);
    paginatedStudentRecords.forEach((_, i) => {
      setTimeout(() => setSRowVisible(prev => { const n = [...prev]; n[i] = true; return n; }), i * 60);
    });
    // eslint-disable-next-line
  }, [search, filter, studentRecords, activeTab, sCurrentPage]);

  useEffect(() => {
    setTRowVisible([]);
    paginatedTeacherRecords.forEach((_, i) => {
      setTimeout(() => setTRowVisible(prev => { const n = [...prev]; n[i] = true; return n; }), i * 60);
    });
    // eslint-disable-next-line
  }, [search, filter, teacherRecords, activeTab, tCurrentPage]);

  /* ── ✅ Sirf jis tab (student/teacher) ka table abhi dikh raha hai
     usi ki, aur sirf current page ke (max 10) records ki loading dikhayein:
     - Jab tab switch ho (students <-> teachers)
     - Jab filter change ho
     - Jab us tab ke andar pagination se dusre page par jayen
     Doosre (chhupe hue) tab ki state change ho tab bhi kuch farak nahi
     padta kyunke wo table render hi nahi ho raha. ── */
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setViewLoading(true);
    const timer = setTimeout(() => setViewLoading(false), 400);
    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, [activeTab, filter, sCurrentPage, tCurrentPage]);

  const handleReturn = (record, isTeacher, setLoading, handleClose) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("booking_id", record.id);

    axios
      .post(`${baseUrl}/admin/bookings/returnBook`, formData,
        { headers: { "Authorization": `Bearer ${authToken}` } }
      )
      .then((res) => {
        setLoading(false);
        if (res.data.success === true) {
          handleClose();
          const fine        = isTeacher ? 0 : (res.data.fine || 0);
          const overdueDays = isTeacher ? 0 : (res.data.overdue_days || 0);

          const updater = prev =>
            prev.map(r => r.id === record.id
              ? { ...r, status: "returned", fine: fine > 0 ? fine : null }
              : r
            );

          if (isTeacher) setTeacherRecords(updater);
          else           setStudentRecords(updater);

          Swal.fire({
            icon: "success",
            title: "Book Returned!",
            html: isTeacher
              ? `Book returned successfully.`
              : fine > 0
                ? `Book returned successfully.<br/>
                   <span style="color:#d97706;font-weight:600;">
                     Fine charged: Rs. ${fine} (${overdueDays} day${overdueDays > 1 ? "s" : ""} overdue)
                   </span>`
                : `Book returned successfully.<br/>
                   <span style="color:#0f8a65;font-weight:600;">No fine — returned on time!</span>`,
            confirmButtonColor: "#1a5f7a",
          });
        } else {
          Swal.fire({ icon: "error", title: "Failed", text: res.data.message || "Something went wrong." });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        Swal.fire({ icon: "error", title: "Error", text: "Something went wrong. Please try again." });
      });
  };

  const handleLost = (record, isTeacher, setLoading, handleClose) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("booking_id", record.id);

    axios
      .post(`${baseUrl}/admin/bookings/markAsLost`, formData,
        { headers: { "Authorization": `Bearer ${authToken}` } }
      )
      .then((res) => {
        setLoading(false);
        if (res.data.success === true) {
          handleClose();
          const fine = res.data.fine || 0;

          const updater = prev =>
            prev.map(r => r.id === record.id ? { ...r, status: "lost", fine } : r);

          if (isTeacher) setTeacherRecords(updater);
          else           setStudentRecords(updater);

          Swal.fire({
            icon: "success",
            title: "Book Marked as Lost",
            html: `<span style="color:#d63031;font-weight:600;">Fine charged: Rs. ${fine}</span>`,
            confirmButtonColor: "#1a5f7a",
          });
        } else {
          Swal.fire({ icon: "error", title: "Failed", text: res.data.message || "Something went wrong." });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        Swal.fire({ icon: "error", title: "Error", text: "Something went wrong. Please try again." });
      });
  };

  const handleDamaged = (record, isTeacher, setLoading, handleClose) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("booking_id", record.id);

    axios
      .post(`${baseUrl}/admin/bookings/markAsDamaged`, formData,
        { headers: { "Authorization": `Bearer ${authToken}` } }
      )
      .then((res) => {
        setLoading(false);
        if (res.data.success === true) {
          handleClose();
          const fine = res.data.fine || 0;

          const updater = prev =>
            prev.map(r => r.id === record.id ? { ...r, status: "damaged", fine } : r);

          if (isTeacher) setTeacherRecords(updater);
          else           setStudentRecords(updater);

          Swal.fire({
            icon: "success",
            title: "Book Marked as Damaged",
            html: `<span style="color:#d97706;font-weight:600;">Fine charged: Rs. ${fine}</span>`,
            confirmButtonColor: "#1a5f7a",
          });
        } else {
          Swal.fire({ icon: "error", title: "Failed", text: res.data.message || "Something went wrong." });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        Swal.fire({ icon: "error", title: "Error", text: "Something went wrong. Please try again." });
      });
  };

  const isStudentsTab = activeTab === "students";
  const switchTab = (tab) => {
    setActiveTab(tab);
    setSearch("");
    setFilter("All");
    setSCurrentPage(1);
    setTCurrentPage(1);
  };

  // ✅ initial fetch loading + tab/pagination/filter ki chhoti loading dono combine
  const showLoader = loading || viewLoading;

  return (
    <div className={`gcAdminIB-page ${visible ? "gcAdminIB-page--visible" : ""}`}>
      <Container fluid className="gcAdminIB-container">

        <div className="gcAdminIB-header">
          <h2 className="gcAdminIB-title">Issued Books</h2>
          <div className="gcAdminIB-controls">
            <div className="gcAdminIB-search-wrap">
              <input
                className="gcAdminIB-search-input"
                type="text"
                placeholder="Search by name or book..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <div className="gcAdminIB-select-wrap">
              <select
                className="gcAdminIB-filter-select"
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
              >
                {STATUS_OPTIONS.map((s) => (
                  <option key={s} value={s}>
                    {s === "All" ? "All" : s.charAt(0).toUpperCase() + s.slice(1)}
                  </option>
                ))}
              </select>
              <span className="gcAdminIB-select-arrow">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                  <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
            </div>
          </div>
        </div>

        <div className="gcAdminIB-tabs">
          <button
            className={`gcAdminIB-tab ${isStudentsTab ? "gcAdminIB-tab--active" : ""}`}
            onClick={() => switchTab("students")}
          >
            Students
            <span className="gcAdminIB-tab-count">{studentRecords.length}</span>
          </button>
          <button
            className={`gcAdminIB-tab ${!isStudentsTab ? "gcAdminIB-tab--active" : ""}`}
            onClick={() => switchTab("teachers")}
          >
            Teachers
            <span className="gcAdminIB-tab-count">{teacherRecords.length}</span>
          </button>
        </div>

        {/* ── ✅ Table + Pagination — ab showLoader use ho raha hai ── */}
        {showLoader ? (
          <Loader
            message={loading
              ? "Issued books loading, please wait..."
              : `${isStudentsTab ? "Student" : "Teacher"} issued books loading...`}
          />
        ) : isStudentsTab ? (
          <>
            <BookTable
              records={paginatedStudentRecords}
              isTeacher={false}
              rowVisible={sRowVisible}
              finePerDay={bookConfig.fine_per_day}
              onView={(r) => { setViewRecord(r); setViewIsTeacher(false); }}
              onReturn={(r) => { setReturnRecord(r); setReturnIsTeacher(false); }}
              onLost={(r) => { setLostRecord(r); setLostIsTeacher(false); }}
              onDamaged={(r) => { setDamagedRecord(r); setDamagedIsTeacher(false); }}
            />
            <Pagination
              currentPage={sCurrentPage}
              totalItems={filteredStudentRecords.length}
              itemsPerPage={ITEMS_PER_PAGE}
              onPageChange={setSCurrentPage}
            />
          </>
        ) : (
          <>
            <BookTable
              records={paginatedTeacherRecords}
              isTeacher={true}
              rowVisible={tRowVisible}
              finePerDay={bookConfig.fine_per_day}
              onView={(r) => { setViewRecord(r); setViewIsTeacher(true); }}
              onReturn={(r) => { setReturnRecord(r); setReturnIsTeacher(true); }}
              onLost={(r) => { setLostRecord(r); setLostIsTeacher(true); }}
              onDamaged={(r) => { setDamagedRecord(r); setDamagedIsTeacher(true); }}
            />
            <Pagination
              currentPage={tCurrentPage}
              totalItems={filteredTeacherRecords.length}
              itemsPerPage={ITEMS_PER_PAGE}
              onPageChange={setTCurrentPage}
            />
          </>
        )}

      </Container>

      {viewRecord && (
        <DetailModal
          record={viewRecord}
          isTeacher={viewIsTeacher}
          finePerDay={bookConfig.fine_per_day}
          onClose={() => setViewRecord(null)}
        />
      )}
      {returnRecord && (
        <ReturnModal
          record={returnRecord}
          isTeacher={returnIsTeacher}
          finePerDay={bookConfig.fine_per_day}
          onClose={() => setReturnRecord(null)}
          onConfirm={handleReturn}
        />
      )}
      {lostRecord && (
        <LostModal
          record={lostRecord}
          isTeacher={lostIsTeacher}
          lostFine={bookConfig.lost_book_fine}
          onClose={() => setLostRecord(null)}
          onConfirm={handleLost}
        />
      )}
      {damagedRecord && (
        <DamagedModal
          record={damagedRecord}
          isTeacher={damagedIsTeacher}
          damagedFine={bookConfig.damaged_book_fine}
          onClose={() => setDamagedRecord(null)}
          onConfirm={handleDamaged}
        />
      )}
    </div>
  );
};

export default AdminIssuedBooks;